<prlw-title-profile-ui
  [profile]="profile$ | async"
  (eventProfileButtonClick)="redirectToSignInIfNotAuthorized()"
></prlw-title-profile-ui>
